import Logs from '../../services/Logs';
import { createRestSlices, applyReducers } from './rest';
import { ActionPayload } from '..';
import Log from '../../models/Log';

const { initialState, listReducer, listAction } = createRestSlices(Logs);

const UPDATE = 'yoda/mercure/REMOTE_UPDATE';
const onRemoteUpdateReducer = (state = initialState, action: ActionPayload) => {
    if (action.type !== UPDATE)
        return state;

    const { update: { data, type }} = action;
    if (type !== 'log.created')
        return state;

    const logs = state.logs || [];
    if (logs.some((log: Log) => log._id === data._id))
        return state;

    return {
        ...state,
        logs: [new Log(data), ...logs].slice(0, Math.max(logs.length, 40))
    };
};

/* Export reducer */
/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (state = initialState, action: ActionPayload) => {
    return applyReducers(state, action, [ listReducer, onRemoteUpdateReducer ]);
}

/* Export CRUD actions */
export const loadLogs = listAction;
